import style from './tabs.module.scss'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import useGetPromissory from 'modules/promissory/hooks/useGetPromissory'
import DotsLoading from 'components/loadings/dotsLoading'
import {
    copyToClipboard,
    formatDueDate,
    getBadgeClass,
    getBadgeText,
    getNoteClass,
} from './utility'
import { FaRegCopy } from 'react-icons/fa6'
import { FaTrashCan } from 'react-icons/fa6'
import { deletePromissory, NewStateInquiry } from 'services/promissory'
import { toast } from 'react-toastify'

export default function CustomTabs() {
    const [activeTab, setActiveTab] = useState<string>('services')
    const [localPromissory, setLocalPromissory] = useState<IPromissory[]>([])
    const [filteredPromissory, setFilteredPromissory] = useState<IPromissory>()
    const { isLoading, data } = useGetPromissory()
    const navigate = useNavigate()

    const handleApiResponse = async () => {
        try {
            const filteredPromissories = localPromissory.filter((promissory) =>
                ['pub', 'sgn', 'unsgn'].includes(promissory.state)
            )

            await Promise.all(
                filteredPromissories.map(async (promissoryArray) => {
                    try {
                        const response = await NewStateInquiry({
                            registrationId: promissoryArray.track_id_publish,
                        })
                        if (response['message'] === 4) {
                            setFilteredPromissory(promissoryArray)
                            navigate('/promissory/promissory-note-details/')
                        } else {
                            toast.info(
                                'لطفا طبق مراحل ابتدا سفته خود را امضا کنید'
                            )
                        }
                    } catch (error) {
                        console.error(
                            `Inquiry failed for track_id: ${promissoryArray.track_id_publish}`,
                            error
                        )
                    }
                })
            )
        } catch (error) {
            console.error('Error handling state:', error)
        }
    }

    useEffect(() => {
        if (data) {
            setLocalPromissory(data)
        }
    }, [data])

    const handleSelect = (k: string | null) => {
        setActiveTab(k ?? 'services')
    }

    const handleDelete = async (request_id) => {
        try {
            const response = await deletePromissory({ request_id })
            const firstInfoMessage: string = response['message']
            toast.info(firstInfoMessage)
            const updatedPromissory = localPromissory.filter(
                (note) => note.request_id !== request_id
            )
            setLocalPromissory(updatedPromissory)
        } catch (error: any) {
            toast.error('مشکلی در حذف سفته پیش آمده. بعدا تلاش کنید', error)
        }
    }

    return (
        <>
            <Tabs
                defaultActiveKey="home"
                onSelect={handleSelect}
                id="fill-tab-example"
                className={classNames(
                    'm-3 sticky bg-white top-[64px] pb-3 z-60',
                    style.myTabs
                )}
                fill
                variant="underline"
            >
                <Tab eventKey="home" title="خدمات">
                    <div className="p-4">
                        <p className="text-justify leading-7 p-3 mt-1 shadow-sm border bg-green-2 rounded w-full">
                            <span className="block font-bold"> مرحله ۱:</span>
                            در این مرحله صادر کننده سفته با وارد کردن اطلاعات
                            خود و اطلاعات دریافت کننده سفته٬ اقدام به صدور پیش
                            نویش سفته خواهد کرد
                        </p>
                        <Link
                            to="/promissory/promissory-publish"
                            className="w-full"
                        >
                            <div className="border bg-green-1 text-white text-center mt-3 rounded-xl p-4">
                                صدور پیش نویس سفته
                            </div>
                        </Link>
                        <p className="text-justify leading-7 p-3 mt-5 shadow-sm border bg-green-2 rounded w-full">
                            <span className="block font-bold"> مرحله ۵:</span>
                            پس از صدرو پیش نویس سفته٬ گواهی امضا در اپلیکیشن
                            امضامی و ارسال سفته در بخش امضای دیجیتال همیان٬ برای
                            نهایی سازی سفته دکمه نهایی سازی سفته را لمس کنید
                        </p>
                        <div
                            className="border bg-green-1 text-white text-center mt-3 rounded-xl p-4"
                            onClick={handleApiResponse}
                        >
                            نهایی سازی سفته الکترونیک
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="profile" title="سفته های من">
                    <div className="">
                        {isLoading ? (
                            <DotsLoading />
                        ) : (
                            <div className="flex flex-col gap-4 justify-center m-4">
                                {localPromissory &&
                                localPromissory.length > 0 ? (
                                    localPromissory
                                        .slice()
                                        .reverse()
                                        .map((note, index) => (
                                            <div
                                                key={index}
                                                className={
                                                    getNoteClass[note.state]
                                                }
                                            >
                                                <div className="flex justify-end text-red-1 text-xl">
                                                    {note.state !== 'fnl' &&
                                                    note.state !== 'del' ? (
                                                        <FaTrashCan
                                                            onClick={() =>
                                                                handleDelete(
                                                                    note.request_id
                                                                )
                                                            }
                                                        />
                                                    ) : null}
                                                </div>
                                                <p className="mb-2">
                                                    صادر کننده سفته:{' '}
                                                    {note.issuer_name}
                                                </p>
                                                <p className="mb-2">
                                                    در وجه: {note.receiver_name}
                                                </p>
                                                <p className="mb-2">
                                                    مبلغ سفته:{' '}
                                                    {note.amount.toLocaleString()}{' '}
                                                    ریال
                                                </p>
                                                <p className="mb-2">
                                                    تاریخ سرسید:{' '}
                                                    {formatDueDate(
                                                        note.due_date
                                                    )}
                                                </p>
                                                <p className="mb-2 flex items-center">
                                                    شماره خزانه داری:{' '}
                                                    <span className="ml-2 flex items-center">
                                                        {note.promissory_id}
                                                        {note.state !==
                                                            'del' && (
                                                            <FaRegCopy
                                                                className="cursor-pointer text-blue-3 mr-2"
                                                                onClick={() =>
                                                                    copyToClipboard(
                                                                        note.promissory_id
                                                                    )
                                                                }
                                                            />
                                                        )}
                                                    </span>
                                                </p>
                                                <span
                                                    className={classNames(
                                                        style.badge,
                                                        getBadgeClass[
                                                            note.state
                                                        ]
                                                    )}
                                                >
                                                    {getBadgeText[note.state]}
                                                </span>
                                            </div>
                                        ))
                                ) : (
                                    <div className=" mx-2 border-2 border-dashed border-green-1 rounded-md items-center text-center p-8 mt-2">
                                        <p className=" text-green-1">
                                            در حال حاضر سفته ایی ندارید
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </Tab>
            </Tabs>
        </>
    )
}
